import { AloftDate, orUndefined, schAloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectOrder } from './orderSelectors.ts';
import { selectReconciliation } from './selectReconciliation.ts';

export const selectOrderDetailsFormValues = createSelector(
  [selectOrder, selectReconciliation],
  (order, reconciliation) => {
    const totalRenovationBudget = orUndefined(schAloftPrice.parse)(
      reconciliation.totalRenovationBudget,
    );

    return {
      effectiveDate: order.effectiveDate ? AloftDate.schema.parse(order.effectiveDate) : undefined,
      inspectionDate: order.inspectionDate
        ? AloftDate.schema.parse(order.inspectionDate)
        : undefined,
      intendedUsers: order.intendedUsers ?? '',
      intendedUse: order.intendedUse ?? '',
      ...(order.hasArvOption ? { totalRenovationBudget } : {}),
    };
  },
);
